import React, { useEffect } from 'react';

//import Scss
import './assets/scss/themes.scss';
import './assets/scss/apihub-theme.css';

//imoprt Route
import Route from './Routes';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";

// Activating fake backend
fakeBackend();
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  useEffect(() => {
    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseConfig = {
      apiKey: "AIzaSyArHrCADcyaE1BXncF4lisvEGHU40ypl9k",
      authDomain: "ai-api-8e4a6.firebaseapp.com",
      projectId: "ai-api-8e4a6",
      storageBucket: "ai-api-8e4a6.appspot.com",
      messagingSenderId: "609096524706",
      appId: "1:609096524706:web:bda2e9c7b6b57819dd88fb",
      measurementId: "G-84PJ4KEWQF"
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    const analytics = getAnalytics(app);
    // console.log(analytics)
  }, [])
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
